import React from 'react'
import { Navigate, useLocation, useParams } from 'react-router'

/**
 * Alias de la convention interne `/documentation/documents/{id}?page={pageId}` — le format
 * émis par les modules générés (TOC, LEP, cross-references) et reconnu par le pipeline PDF
 * (signets GoTo) et le gel des renvois. Les snapshots publiés le portent figé : on route la
 * forme historique vers le studio plutôt que de réécrire les émetteurs et les archives.
 */
const DocumentPageRedirectInternal: React.FC = () => {
  const { id } = useParams()

  const { search } = useLocation()

  return <Navigate to={`/documentation/manuals/${id}/edit${search}`} replace />
}

export const DocumentPageRedirect = React.memo(DocumentPageRedirectInternal)
